<template>
  <div :class="{ hero: isHome }" class="wrapper header">
    <div class="top-nav">
      <div class="top-nav-inner">
        <router-link as="a" to="/" class="link hero navigation-link">
          <svg-icon :icon="'home'" class="logo" />
        </router-link>
      </div>
    </div>
    <div v-if="isHome" class="video-wrapper">
      <video autoplay loop muted playsinline :poster="content.personalData.heroPosterImage">
        <source
          :src="content.personalData.heroVideo"
          type="video/mp4"
        />
      </video>
    </div>
    <div class="container header">
      <div v-if="isHome" class="hero-text">
  <h1>{{ content.personalData.heroHeading }}</h1>
  {{ content.personalData.heroText }}
  <div class="hero-icons">
    <svg-icon :icon="'email'" />
    <svg-icon :icon="'linkedin'" />
  </div>
</div>
    </div>
  </div>
</template>

<script>
import content from "../../public/content.json";
import SvgIcon from "./SvgIcon.vue";

export default {
  name: "Header",
  components: {
    SvgIcon,
  },
  data: function () {
    return {
      content,
    };
  },
  computed: {
    isHome() {
      return this.$route.path === "/";
    },
  },
};
</script>

<style lang="scss" scoped>
$tablet: "screen and (max-width: 700px)";
$mobile: "screen and (max-width: 500px)";

.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
.top-nav-inner {
  margin: 0 auto;
  max-width: var(--container-default);
}
.wrapper {
  position: relative;
  width: 100%;
  color: white;
  background: var(--color-bg);
  z-index: 1;
  overflow: hidden;
  &.header {
    &.hero {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
      margin-bottom: 0px;
      background-color: rgb(0, 0, 0);
      z-index: 2;
    }
    .video-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      background-position: left;
      z-index: -1;
      height: 100vh;
      video {
        width: 100vw;
        height: 100vh;
        object-fit: cover;
        object-position: center;
        min-width: 100%;
        min-height: 100%;
      }
    }
  }
    .hero-text {
      display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  }

  .hero-icons {
    display: flex;
    flex-direction: row;
    gap: 20px;
    margin-top: 20px;
    justify-content: center;
    .icon-link {
      transition: transform 0.2s ease;
      color: white;
      &:hover {
        transform: scale(1.1);
      }
    }
  }
}
.header {
  position: relative;
  height: 100%;
  margin: 0 auto;
  @media #{$mobile} {
    align-items: center;
  }
  .title {
    display: inline;
    @media #{$tablet} {
      display: block;
      .dash {
        display: none;
      }
    }
    @media #{$mobile} {
      display: none;
    }
  }
  .navigation {
    margin-left: auto;
    .dropdown {
      position: relative;
      .portfolio-dropdown {
        position: absolute;
        top: calc(100% + 4px);
        right: calc(0px - var(--spacing-small));
        text-transform: none;
        text-align: right;
        padding: var(--spacing-small);
        min-width: 18rem;
        background: var(--color-bg);
        display: none;
        .portfolio-dropdown-list {
          .portfolio-dropdown-item {
            margin: 0 0 0.8rem 0;
          }
          &:last-child {
            display: none;
          }
        }
        &.active {
          display: block;
        }
      }
    }
    .navigation-link {
      margin-left: var(--spacing-small);
      border-bottom: 1px solid transparent;
      padding-top: var(--spacing-small);
      &:hover,
      &.router-link-exact-active {
        border-bottom: 1px solid var(--color-gray);
      }
      &.login:hover {
        border-bottom: none;
      }
    }
  }
  .navigation-link {
    display: inline-block;
    position: relative;
    font-size: var(--font-size-medium-small);
    margin: var(--spacing-large);
  }
  $icon: 1.6rem;
  .header-right {
    display: inline-flex;
    position: relative;
    .icon {
      width: $icon;
      height: $icon;
      margin-left: var(--spacing-small);
    }
  }
}
  .hero .navigation-link {
    display: none;
  }
</style>